import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {

  requestType: string = "order";
  orderDone : boolean = true;
  orderDoneReviewed : boolean = false;
  hideActionsColumn : boolean = false;

  title: string = "أوامر الصيانة";

  constructor() { }

  ngOnInit() {
  }

}
